function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M45.923 18.202C42.169 6.647 29.757.322 18.202 4.077S.323 20.244 4.077 31.798s16.167 17.879 27.722 14.125C43.353 42.169 49.677 29.756 45.923 18.202L45.923 18.202zM25.025 7.023L25.025 16.011"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M25 15L15.537 21.875 19.151 33 30.849 33 34.463 21.875zM18.536 3.967L25 8 31.464 3.967 25.092 2.705z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M8.223 19.525L16.163 22.081"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M2.999 24.648L8.832 19.747 6.994 12.353 4.016 17.718z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M14.587 39.29L19.755 32.173"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M17.866 45.815L15.008 38.753 7.408 38.217 11.561 42.709z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M35.683 39.746L30.114 31.973"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M42.592 38.217L34.992 38.753 32.134 45.815 37.534 42.819z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M42.565 19.319L33.489 22.193"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M43.006 12.353L41.168 19.747 47.001 24.648 45.971 18.17z"
});

function SvgSoccer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoccer);
export default __webpack_public_path__ + "static/media/soccer.a29acf67.svg";
export { ForwardRef as ReactComponent };